import React from 'react';
import { Card, Row, Col, Typography, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import rolesIllustration from 'assets/roles.png';
import Layer_1 from 'assets/Layer_1.png';
import Work from 'assets/Work.png';
import jobacc from 'assets/jobacc.png';
import totalclg from 'assets/totalclg.png';
import {
  RightOutlined,
  BankOutlined,
  FileTextOutlined,
} from '@ant-design/icons';
import { useSelector } from 'react-redux';

const { Text, Title } = Typography;

const StatsRow = ({ selectedFilter }) => {
  const navigate = useNavigate();
  const metricsData = useSelector(state => state?.corporateDashboardPage2?.metricsData);

  // Dynamic data from API
  const rolesData = [
    { label: "Roles open", prev: metricsData?.openRoles || 0,},
    { label: "Roles drafted", prev: metricsData?.draftRoles || 0,},
    { label: "Roles closed", prev: metricsData?.closedRoles || 0,},
  ];

  const statsData = [
    { icon: <img src={totalclg} alt="totalclg" style={{ fontSize: 18 }} />, title: "Total no. of Colleges", curr: metricsData?.totalCollegeCount || 0 },
    { icon: <img src={jobacc} alt="jobacc" style={{ fontSize: 18 }} />, title: "Job Accpt. Percentage", curr: `${metricsData?.roleAcceptPercent || 0}%` },
    { icon: <img src={Work} alt="Work" style={{ fontSize: 18 }} />, title: "Hires", curr: metricsData?.hireCount || 0 },
  ];

  const handleRoleClick = (type) => {
    if (type === "Roles open") navigate("/rolePage");
    else if (type === "Roles drafted") navigate("/rolePage");
    else if (type === "Roles closed") navigate("/rolePage");
  };

  return (
    <Row gutter={[16, 16]} align="stretch" style={{ marginTop: 10 }}>
      {/* Roles */}
      <Col xs={24} sm={24} md={12} lg={10}>
        <Card className="cd-card" bordered={true} bodyStyle={{ padding: 18 }} style={{ height: '100%' }}>
          <Row align="middle" justify="space-between">
            <Col span={24}>
              <Row gutter={[0, 12]}>
                {rolesData.map((r, i) => (
                  <Col span={24} key={i}>
                    <div
                      onClick={() => handleRoleClick(r.label)}
                      style={{ 
                        display: "flex", 
                        justifyContent: "space-between", 
                        alignItems: "center", 
                        background: "#ffffff", 
                        borderRadius: 10, 
                        padding: "9px 20px", 
                        cursor: "pointer", 
                        transition: "all 0.12s ease",
                        width: "100%",
                        height: 53,
                        border: "1px solid rgba(222, 222, 222, 1)",
                        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.background = "#f0f5ff")}
                      onMouseLeave={(e) => (e.currentTarget.style.background = "#ffffff")}
                    >
                      <Text style={{ fontSize: 15 }}>{r.label}</Text>
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <Text style={{ color: "#1852d0", fontWeight: 600 }}>{r.prev} <Text type="secondary"></Text></Text>
                        {/* <Text style={{ color: "#1852d0", fontWeight: 600 }}>{r.curr} <Text type="secondary">(2025)</Text></Text> */}
                        <RightOutlined style={{ color: "#1852d0", fontSize: 12 }} />
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Card>
      </Col>

      {/* Applicants */}
      <Col xs={24} sm={24} md={6} lg={7}>
        <Card className="cd-card" bordered={false} bodyStyle={{ padding: 18 }} style={{ height: '100%' }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <img src={Layer_1} alt="Applicants" style={{ color: "#1852d0", fontSize: 18, width: 24, height: 24 }} />
            </div>
            <Text style={{ 
              fontFamily: 'Plus Jakarta Sans',
              fontWeight: 400,
              fontSize: 18,
              lineHeight: '15px',
              letterSpacing: '0%',
              marginTop: 8
            }}>No. of Applicants</Text>
            <Text style={{ 
              fontFamily: 'Plus Jakarta Sans',
              fontWeight: 'bold',
              fontSize: 18,
              lineHeight: '15px',
              letterSpacing: '0%',
              marginTop: 12
            }}>Total: {metricsData?.applicantsCount?.count || 0}</Text>
          </div>
          <Row gutter={16} style={{ marginTop: 16 }}>
            <Col span={14}>
              {/* <Text type="secondary" style={{ fontSize: 13 }}>Freshers</Text> */}
              <Title level={5} style={{ color: "#1852d0", margin: "2px 0", fontWeight: 600 }}>
                {metricsData?.applicantsCount?.male || 0}<span style={{ color: "" ,fontSize: 18}}> (M)</span> / 
                {metricsData?.applicantsCount?.female || 0}<span style={{ color: "",fontSize: 18  }}> (F)</span> / 
                {metricsData?.applicantsCount?.others || 0}<span style={{ color: "",fontSize: 18 }}> (O)</span>
              </Title>
            </Col>
            {/* <Col span={12}>
              <Text type="secondary" style={{ fontSize: 13 }}>Experienced</Text>
              <Title level={5} style={{ color: "#1852d0", margin: "2px 0", fontWeight: 600 }}>125m / 98f</Title>
              <Text style={{ color: "#ff4d4f", fontSize: 12 }}>/ -4m / 4f than 2021</Text>
            </Col> */}
          </Row>
        </Card>
      </Col>

      {/* Stats */}
      <Col xs={24} sm={24} md={6} lg={7}>
        <div style={{ display: "flex", flexDirection: "column", gap: 12, height: '100%' }}>
          {statsData.map((item, i) => (
            <div
              key={i}
              className="cd-stat-card"
              style={{ cursor: "pointer", flexGrow: 1 }} // Added flexGrow
              onMouseEnter={(e) => (e.currentTarget.style.background = "#f0f5ff")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
            >
              <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                <Col>
                  <Space align="center" size={12}>{item.icon}<Text style={{ fontSize: 15 }}>{item.title}</Text></Space>
                </Col>
                <Col>
                  <Text style={{ color: "#1852d0", fontWeight: 600 }}>
                    {item.curr} <Text type="secondary" style={{ fontSize: 12 }}></Text>
                  </Text>
                </Col>
              </Row>
            </div>
          ))}
        </div>
      </Col>
    </Row>
  );
};

export default StatsRow;